import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { setForbiddenErrorCallback } from '../../../services/api/client';

const ForbiddenErrorContext = createContext(null);

export function ForbiddenErrorProvider({ children }) {
  const [errorState, setErrorState] = useState({
    open: false,
    referenceId: null,
  });

  const showForbiddenError = useCallback((referenceId) => {
    setErrorState({
      open: true,
      referenceId,
    });
  }, []);

  // Register callback with API client
  useEffect(() => {
    setForbiddenErrorCallback(showForbiddenError);
    return () => {
      setForbiddenErrorCallback(null);
    };
  }, [showForbiddenError]);

  const hideForbiddenError = useCallback(() => {
    setErrorState({
      open: false,
      referenceId: null,
    });
  }, []);

  return (
    <ForbiddenErrorContext.Provider
      value={{
        ...errorState,
        showForbiddenError,
        hideForbiddenError,
      }}
    >
      {children}
    </ForbiddenErrorContext.Provider>
  );
}

export function useForbiddenError() {
  const context = useContext(ForbiddenErrorContext);
  if (!context) {
    throw new Error('useForbiddenError must be used within a ForbiddenErrorProvider');
  }
  return context;
}
